import { RootState } from "@/store/types";
import { ActionTree, Module } from "vuex";
import { ProductSpecificRuleExceptionsState } from "@/modules/product_specific_rule_exceptions/types";
import {getProductSpecificRuleExceptions} from "@/services/product_specific_rule_exceptions";

const actions: ActionTree<ProductSpecificRuleExceptionsState, RootState> = {
    async GET_PRODUCT_SPECIFIC_RULE_EXCEPTIONS(_, payload) {
      return await getProductSpecificRuleExceptions(payload)
  }
}
  
export const product_specific_rule_exceptions: Module<ProductSpecificRuleExceptionsState, RootState> = {
    actions,
}
  